import { UserCompany } from '@web-shared/api/types/UserCompany.types';
import { ApiCall } from '@web-shared/services/http-service/types/ApiCall';

import { httpService } from './http';

export const fetchUserCompanies: ApiCall<null, UserCompany[]> = async ({ abortSignal }) => {
  const res = await httpService.get(
    '/api/v3/account/authorization/companies',
    null,
    abortSignal,
  );
  return res.data as UserCompany[];
};
